import React, { useState } from 'react';
import ImageWithBasePath from '../../../../core/common/imageWithBasePath';
import { Link } from 'react-router-dom';
import './LeadsTabs.css';

type CheckedState = {
  id: string | null;
  isChecked: boolean;
};

const RecentTask = ({ setselectedId ,handleShowConfirmModal}: any) => {
  const [checkedState, setCheckedState] = useState<CheckedState>({ id: null, isChecked: false });
  const [expandedTask, setExpandedTask] = useState<string | null>(null);

  const handleLinkClick = (id: string) => {
    setExpandedTask((prevState) => (prevState === id ? null : id));
  };

  const handleConfirmAssign=(e:any)=>{
    e.preventDefault()
    handleShowConfirmModal()
  }

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
    e.stopPropagation();
    setCheckedState((prevState) => {
      const newCheckedState = {
        id,
        isChecked: prevState.id === id ? !prevState.isChecked : true,
      };

      // Set the selected ID when the checkbox is checked
      if (newCheckedState.isChecked) {
        setselectedId(id);
      } else {
        setselectedId(null);
      }

      return newCheckedState;
    });
  };

  return (
    <>
      <div className="task-wrapper">
        <Link
          to="#"
          className="task-accordion"
          data-bs-toggle="collapse"
          data-bs-target="#recent"
        >
          <h4 className='color-red'>
            Recent Tasks
          </h4>
        </Link>
        <div
          className="tasks-activity show tasks w-100 collapse"
          id="recent"
        >
          <ul>
            <div className="task-checkbox">
              <label className="checkboxs">
                <input
                  type="checkbox"
                  checked={checkedState.id === '1' && checkedState.isChecked}
                  onChange={(e) => handleCheckboxChange(e, '1')}
                />
                <span className="checkmarks checkcss" />
              </label>
            </div>
          </ul>
          <ul>
            <Link to='#' className="task-wrap pending" data-bs-toggle="collapse"
              data-bs-target="#collapseExample1" id='1'
              onClick={() => handleLinkClick('1')}>
              <div className="task-info">
                <p>Create BluePrints For The Marketing campaigns </p>
                <p className='text-muted'>created by</p>
                <p>Daniel Wilson </p>
                <p className='text-muted'>In</p>
                <p>L-23012</p>
                <p className='text-muted'>at</p>
                <p>9/29/24 03:36:32 PM</p>
              </div>
              <div className="task-actions">
                <ul>
                  <li className="task-time d-flex gap-2">
                    <p className='mb-0'><b onClick={handleConfirmAssign}>Assigned To:</b> None</p>
                    <p className="badge badge-tag badge-success-light mb-0">
                      <i className='fa fa-circle fs-10'></i>Medium
                    </p>
                    <p className="badge bg-soft-gray mb-0">
                      Not Started
                    </p>
                  </li>
                </ul>
              </div>
              <div
                className={`collapse ${expandedTask === '1' ? 'show' : ''}`}
                id="collapseExample1"
              >
                <p><b>Description:</b>Implement and manage a lead scoring system to prioritise leads based on their likelihood to convert</p> </div>
            </Link>
          </ul>

          {/* dummy data added */}

          <ul>
            <div className="task-checkbox">
              <label className="checkboxs">
                <input
                  type="checkbox"
                  checked={checkedState.id === '2' && checkedState.isChecked}
                  onChange={(e) => handleCheckboxChange(e, '2')}
                />
                <span className="checkmarks checkcss" />
              </label>
            </div>
          </ul>
          <ul>
            <Link to='#' className="task-wrap pending" data-bs-toggle="collapse"
              data-bs-target="#collapseExample2" id='2'
              onClick={() => handleLinkClick('2')}>
              <div className="task-info">
                <p>Create BluePrints For The New Leads</p>
                <p className='text-muted'>created by</p>
                <p>Laura Martinez</p>
                <p className='text-muted'>In</p>
                <p>L-23012</p>
                <p className='text-muted'>at</p>
                <p>4/4/2025 3:50:30 pm</p>
              </div>
              <div className="task-actions">
                <ul>
                  <li className="task-time d-flex gap-2">
                    <p className='mb-0'><b>Assigned To:</b> None</p>
                    <p className="badge badge-tag badge-success-light mb-0">
                      <i className='fa fa-circle fs-10'></i>Medium
                    </p>
                    <p className="badge bg-soft-gray mb-0">
                      Not Started
                    </p>
                  </li>
                </ul>
              </div>
              <div
                className={`collapse ${expandedTask === '2' ? 'show' : ''}`}
                id="collapseExample2"
              >
                <p><b>Description:</b>Track and manage opportunities throughout the sales pipeline. Update the status of deals, identify bottlenecks, and forecast future sales.</p> </div>
            </Link>
          </ul>
          <ul>
            <div className="task-checkbox">
              <label className="checkboxs">
                <input
                  type="checkbox"
                  checked={checkedState.id === '3' && checkedState.isChecked}
                  onChange={(e) => handleCheckboxChange(e, '3')}
                />
                <span className="checkmarks checkcss" />
              </label>
            </div>
          </ul>
          <ul>
            <Link to='#' className="task-wrap pending" data-bs-toggle="collapse"
              data-bs-target="#collapseExample3" id='3'
              onClick={() => handleLinkClick('3')}>
              <div className="task-info">
                <p>Create BluePrints For Sales Created</p>
                <p className='text-muted'>created by</p>
                <p> David Lee</p>
                <p className='text-muted'>In</p>
                <p>L-23012</p>
                <p className='text-muted'>at</p>
                <p>10/19/24 02:16:32 PM</p>
              </div>
              <div className="task-actions">
                <ul>
                  <li className="task-time d-flex gap-2">
                    <p className='mb-0'><b>Assigned To:</b> None</p>
                    <p className="badge badge-tag badge-success-light mb-0">
                      <i className='fa fa-circle fs-10'></i>Medium
                    </p>
                    <p className="badge bg-soft-gray mb-0">
                      Not Started
                    </p>
                  </li>
                </ul>
              </div>
              <div
                className={`collapse ${expandedTask === '3' ? 'show' : ''}`}
                id="collapseExample3"
              >
                <p><b>Description:</b>Assess and qualify new leads by gathering relevant information about their needs, budget, and timeline. Determine if the lead is a good fit for the company's products or services and assign a priority level.</p></div>
            </Link>
          </ul>
          <ul>
            <div className="task-checkbox">
              <label className="checkboxs">
                <input
                  type="checkbox"
                  checked={checkedState.id === '4' && checkedState.isChecked}
                  onChange={(e) => handleCheckboxChange(e, '4')}
                />
                <span className="checkmarks checkcss" />
              </label>
            </div>
          </ul>
          <ul>
            <Link to='#' className="task-wrap pending" data-bs-toggle="collapse"
              data-bs-target="#collapseExample4" id='4'
              onClick={() => handleLinkClick('4')}>
              <div className="task-info">
                <p>Create BluePrints For Prioritising leads </p>
                <p className='text-muted'>created by</p>
                <p>Daniel Wilson</p>
                <p className='text-muted'>In</p>
                <p>L-23012</p>
                <p className='text-muted'>at</p>
                <p>9/29/24 03:36:32 PM</p>
              </div>
              <div className="task-actions">
                <ul>
                  <li className="task-time d-flex gap-2">
                    <p className='mb-0'><b>Assigned To:</b> None</p>
                    <p className="badge badge-tag badge-success-light mb-0">
                      <i className='fa fa-circle fs-10'></i>Medium
                    </p>
                    <p className="badge bg-soft-gray mb-0">
                      Not Started
                    </p>
                  </li>
                </ul>
              </div>
              <div
                className={`collapse ${expandedTask === '4' ? 'show' : ''}`}
                id="collapseExample4"
              >
                <p><b>Description:</b>Plan and execute marketing campaigns to generate leads and promote products or services. Track the performance and adjust strategies as needed.</p> </div>
            </Link>
          </ul>
          <ul>
            <div className="task-checkbox">
              <label className="checkboxs">
                <input
                  type="checkbox"
                  checked={checkedState.id === '5' && checkedState.isChecked}
                  onChange={(e) => handleCheckboxChange(e, '5')}
                />
                <span className="checkmarks checkcss" />
              </label>
            </div>
          </ul>
          <ul>
            <Link to='#' className="task-wrap pending" data-bs-toggle="collapse"
              data-bs-target="#collapseExample5" id='5'
              onClick={() => handleLinkClick('5')}>
              <div className="task-info">
                <p>Create BluePrints For The Room</p>
                <p className='text-muted'>created by</p>
                <p>Me</p>
                <p className='text-muted'>In</p>
                <p>L-23012</p>
                <p className='text-muted'>at</p>
                <p>9/29/24 03:36:32 PM</p>
              </div>
              <div className="task-actions">
                <ul>
                  <li className="task-time d-flex gap-2">
                    <p className='mb-0'><b>Assigned To:</b> None</p>
                    <p className="badge badge-tag badge-success-light mb-0">
                      <i className='fa fa-circle fs-10'></i>Medium
                    </p>
                    <p className="badge bg-soft-gray mb-0">
                      Not Started
                    </p>
                  </li>
                </ul>
              </div>
              <div
                className={`collapse ${expandedTask === '5' ? 'show' : ''}`}
                id="collapseExample5"
              >
                <p><b>Description:</b>
                  Collect and analyse customer feedback to identify areas for improvement and enhance the overall customer experience.
                </p></div>
            </Link>
          </ul>
        </div>
        <div className='mt-5'>
        <Link
          to="#"
          className="task-accordion"
          data-bs-toggle="collapse"
          data-bs-target="#yesterday"
        >
          <h4 className='color-red'>
            Yesterday Tasks
          </h4>
        </Link>
        <div
          className="tasks-activity show tasks w-100 collapse"
          id="yesterday"
        >
          <ul>
            <div className="task-checkbox">
              <label className="checkboxs">
                <input
                  type="checkbox"
                  checked={checkedState.id === '1' && checkedState.isChecked}
                  onChange={(e) => handleCheckboxChange(e, '1')}
                />
                <span className="checkmarks checkcss" />
              </label>
            </div>
          </ul>
          <ul>
            <Link to='#' className="task-wrap pending" data-bs-toggle="collapse"
              data-bs-target="#collapseExample1" id='1'
              onClick={() => handleLinkClick('1')}>
              <div className="task-info">
                <p>Create BluePrints For The Marketing campaigns </p>
                <p className='text-muted'>created by</p>
                <p>Daniel Wilson </p>
                <p className='text-muted'>In</p>
                <p>L-23012</p>
                <p className='text-muted'>at</p>
                <p>9/29/24 03:36:32 PM</p>
              </div>
              <div className="task-actions">
                <ul>
                  <li className="task-time d-flex gap-2">
                    <p className='mb-0'><b>Assigned To:</b> None</p>
                    <p className="badge badge-tag badge-success-light mb-0">
                      <i className='fa fa-circle fs-10'></i>Medium
                    </p>
                    <p className="badge bg-soft-gray mb-0">
                      Not Started
                    </p>
                  </li>
                </ul>
              </div>
              <div
                className={`collapse ${expandedTask === '1' ? 'show' : ''}`}
                id="collapseExample1"
              >
                <p><b>Description:</b>Implement and manage a lead scoring system to prioritise leads based on their likelihood to convert</p> </div>
            </Link>
          </ul>

          {/* dummy data added */}
          <ul>
            <div className="task-checkbox">
              <label className="checkboxs">
                <input
                  type="checkbox"
                  checked={checkedState.id === '5' && checkedState.isChecked}
                  onChange={(e) => handleCheckboxChange(e, '5')}
                />
                <span className="checkmarks checkcss" />
              </label>
            </div>
          </ul>
          <ul>
            <Link to='#' className="task-wrap pending" data-bs-toggle="collapse"
              data-bs-target="#collapseExample5" id='5'
              onClick={() => handleLinkClick('5')}>
              <div className="task-info">
                <p>Create BluePrints For The Room</p>
                <p className='text-muted'>created by</p>
                <p>Me</p>
                <p className='text-muted'>In</p>
                <p>L-23012</p>
                <p className='text-muted'>at</p>
                <p>9/29/24 03:36:32 PM</p>
              </div>
              <div className="task-actions">
                <ul>
                  <li className="task-time d-flex gap-2">
                    <p className='mb-0'><b>Assigned To:</b> None</p>
                    <p className="badge badge-tag badge-success-light mb-0">
                      <i className='fa fa-circle fs-10'></i>Medium
                    </p>
                    <p className="badge bg-soft-gray mb-0">
                      Not Started
                    </p>
                  </li>
                </ul>
              </div>
              <div
                className={`collapse ${expandedTask === '5' ? 'show' : ''}`}
                id="collapseExample5"
              >
                <p><b>Description:</b>
                  Collect and analyse customer feedback to identify areas for improvement and enhance the overall customer experience.
                </p></div>
            </Link>
          </ul>
        </div>
      </div>
      </div>
    </>
  );
};

export default RecentTask;
